export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6767.ad12545e.jpg";